/**
 * Resolves the organizer sentinel on a plan-seeded email composition into a
 * concrete From value.
 *
 * ScheduleInterview filters the `organizer` sentinel out of the From picker,
 * so any plan defaulting to it has to be swapped before the step can save.
 * The scheduler themselves is the sender — whether or not they can actually
 * send: `defaultFromValueForCurrentUser` no longer checks the delegatable list,
 * because sending as whichever teammate sorts first is a worse outcome than
 * showing the recruiter their own name beside an error that explains it
 * (ENG-3916).
 *
 * It still propagates an empty seed verbatim, which is what a session with no
 * current user resolves to — that raises the existing "From is required".
 */
import type { EmailCompositionValue } from '@kula-ai/components';
import { INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE } from '../../../InterviewActivity/communication/types';
import { patchEmailComposition } from '../../../InterviewActivity/communication/helpers/emailUtils';

/**
 * `null` when nothing needs changing, so callers can skip the dispatch.
 */
export function seedSenderFrom(
  composition: EmailCompositionValue,
  seedValue: string
): EmailCompositionValue | null {
  if (composition.from !== INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE) return null;
  return patchEmailComposition(composition, { from: seedValue });
}
